import { getApis } from 'library/Apis';
import { EscolaDTO } from 'models/escola';
import { toRequest } from 'utils/RequestUtils';
import api from './api';

const getEndpoint = (version: number, path = '/escola') => {
  return `${getApis().apis.backofficeProjetos}v${version}${path}`;
};

export const getEscolasOptions = (necessaria?: number | null) => {
  const url = getEndpoint(1);
  return toRequest<EscolaDTO[]>(api.post, [
    url,
    necessaria ? [necessaria] : [],
  ]);
};
